import React from "react";
import PropTypes from "prop-types";
import objectAssign from "object-assign";
import { bindActionCreators } from "redux";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import * as courseActions from "../../actions/courseActions";
import SvgIcon from "../icon/SvgIcon";
import { courseDetailRoute } from "../../constants/routeConfig";
import * as courseUtilities from "../../utilities/courseUtilities";
import CourseOfferingImage from "./CourseOfferingImage";
import courseOffering from "../../proptypes/courses/courseOffering";
import courseOfferingMethods from "../../proptypes/courses/courseOfferingMethod";
import courseOfferingFormat from "../../proptypes/courses/courseOfferingFormat";
import { COURSE_SERIES } from "../../constants/courseSeriesLookup";
import { CONFIGURATION } from "../../constants/config";
import User from "../../proptypes/users/User";
import ProgressBar from "../inputs/ProgressBar";
import ICalButton from "../inputs/ICalButton";
import DropCourseButton from "../inputs/DropCourseButton";
import PlayButton from "../inputs/PlayButton";
import AddRemoveCartButton from "../shopping/AddRemoveCartButton";
import { selectIsLoadingRegisteredCourses } from "../../selectors/authSelectors";
import LoadingSpinnerOverlay from "../LoadingSpinnerOverlay";
import loadingStates from "../../constants/loadingStates";


class CourseOfferingCard extends React.Component {
  constructor(props) {
    super(props);

    this.thumbnailRef = React.createRef();

    this.courseDetailUrl = courseDetailRoute(
      this.props.courseOffering.id,
      this.props.courseOffering.format
    );
  }

  render() {
    let {
      myCourses,
      courseOffering,
      showButtons,
      currentUser,
      isLoadingRegistration,
    } = this.props;
    let courseRegistration =
      currentUser &&
      currentUser.registeredCourses &&
      courseUtilities.getCurrentRegistration(
        currentUser.registeredCourses,
        courseOffering.uniqueId
      );
    let isLive = courseOffering.method === courseOfferingMethods.LIVE;
    let onDemand = courseOffering.method === courseOfferingMethods.ON_DEMAND;
    let hasLocation = courseOffering.location ? true : false;
    let isComplianceCourse =
      courseOffering.course.seriesId === COURSE_SERIES.COMPLIANCE_CONNECTIONS;
    let isSLAUniversityCourse =
      courseOffering.course.seriesId === COURSE_SERIES.SLA_UNIVERSITY;
    let isNonCeCourse =
      courseOffering.course.seriesId === COURSE_SERIES.COMPLIANCE_CONNECTIONS ||
      (onDemand && courseOffering.course.name === CONFIGURATION.INTRO_COURSE_NAME);

    const city =
      hasLocation &&
      courseOffering.location.address &&
      courseOffering.location.address.city;
    return (
      <div className={`course-card ${courseOffering.method}`}>
        <div className="course-card-image-container">
        <div className="course-card-image">
            <CourseOfferingImage courseOffering={courseOffering} />
        </div>
        </div>

        <div className="course-card-details">
          <div className="course-text">
            {isLive && (
              <div className="course-status info">
                <span>
                  <SvgIcon icon="cal" color="white" />
                </span>
                {isLive &&
                  courseOffering.format == courseOfferingFormat.WEBINAR && (
                    <span> Live Webinar </span>
                  )}
                {isLive &&
                  courseOffering.format == courseOfferingFormat.IN_PERSON && (
                    <span>  Live In-Person </span>
                  )}
                {/* Course status temporarily commented  */}
                {/* <span> {courseOffering.statusText} </span> */}
              </div>
            )}

            {onDemand && (
              <div className="course-status on-demand">
                <span>
                  <SvgIcon icon="play-screen" color="white" />
                </span>
                <span> On Demand </span>
              </div>
            )}

            <div className="card-body">
              <h5 className="card-title">
                <b>
                  <NavLink to={this.courseDetailUrl}>
                    <MediaQuery maxWidth={CONFIGURATION.MAX_XS_WIDTH}>
                      {(matches) => {
                        //need to display shorter titles on mobile
                        if (matches)
                          return courseUtilities.truncateCourseName(
                            courseOffering.course.name,
                            40
                          );
                        else
                          return courseUtilities.truncateCourseName(
                            courseOffering.course.name,
                            70
                          );
                      }}
                    </MediaQuery>
                  </NavLink>
                </b>
              </h5>
              {courseOffering.presenters.length > 0 && (
                <p className="card-text">
                  <span className="with"> with </span>
                  {courseUtilities.formatPresenterString(
                    courseOffering.presenters
                  )}
                </p>
              )}
              {onDemand && <span><b>Published: {courseOffering.publishDate === '' ? null : courseUtilities.formatMMMDDYYYYDate(courseOffering.publishDate)}</b> </span>}

              {isLive && (
                <hr className="course-content-divider info" />
              )}

              {onDemand && <hr className="course-content-divider on-demand" />}

              {isNonCeCourse && (
                <div className="course-sub-status card-header">
                  <span> COURSE NOT ELIGIBLE FOR CE CREDITS </span>
                </div>
              )}

              {!myCourses && (
                <p className="block-with-text">
                  {courseOffering.summaryDescription}
                </p>
              )}

            </div>
            <div className="course-subtext">
              <div className="course-subtext-container">
                <div className="bottom-left">
                  {isLive &&
                    courseOffering.format == courseOfferingFormat.WEBINAR && (
                      <p>
                        <SvgIcon icon="webinar-sm" />{" "}
                        <span className="detail">Webinar</span>
                      </p>
                    )}
                  {isLive &&
                    courseOffering.format == courseOfferingFormat.IN_PERSON &&
                    hasLocation &&
                    courseOffering.location.address && (
                      <p>
                        <SvgIcon icon="pin-sm" />{" "}
                        <span className="detail">
                          {myCourses
                            ? courseUtilities.abbreviateOfferingLocation(city)
                            : city}
                        </span>
                      </p>
                    )}
                  {isLive && (
                    <p>
                      <SvgIcon icon="cal-sm" />{" "}
                      <span className="detail">
                        {myCourses
                          ? courseUtilities.formatDateTime(
                            courseOffering.date
                          )
                          : courseUtilities.formatDateTime(
                            courseOffering.date
                          )}
                      </span>
                    </p>
                  )}
                  {(courseOffering.duration > 0 || courseOffering.date) && (
                    <p>
                      <SvgIcon icon="clock-sm" />{" "}
                      {
                        courseOffering.duration > 0 &&
                        <span>
                          {courseUtilities.formatDuration(
                            courseOffering.duration
                          )}
                        </span>
                      }
                      {isLive && courseOffering.duration > 0 && courseOffering.date && <span>|</span>}
                      {isLive && courseOffering.date && <span>{courseUtilities.formatTime(courseOffering.date)} PT</span>}
                    </p>
                  )}
                  <p>
                    <SvgIcon icon="credits-number-sm" />{" "}

                    {" "}
                    {(courseOffering.course.ceHours == 0) && (
                      <span className="detail">
                        No Credit
                      </span>
                    )}
                    {(courseOffering.course.ceHours > 0) && (
                      <span className="detail">
                        {courseOffering.course.ceHours} Credits
                      </span>
                    )}
                  </p>
                  {!isNonCeCourse && (
                    <p>
                      <SvgIcon icon="course-number-sm" />{" "}
                      <span className="detail">
                        Course #{courseOffering.course.cdiCourseCode}
                      </span>
                    </p>
                  )}

                  {(isComplianceCourse || isSLAUniversityCourse) && (
                    <span>
                      {isComplianceCourse && (
                        <p>
                          <SvgIcon icon="compliance-connections" />
                          <span className="detail">Compliance </span>
                        </p>

                      )}
                      {isSLAUniversityCourse && (
                        <p>
                          <SvgIcon icon="sla-university" />{" "}
                          <span className="detail">SLA University </span>
                        </p>
                      )}

                    </span>
                  )}

                </div>
                <div className="bottom-right">
                  <NavLink className="clickable" to={this.courseDetailUrl}>
                    <SvgIcon icon="info" />
                    Details
                  </NavLink>
                </div>
              </div>
            </div>
            {courseRegistration && courseRegistration.progress && !isLive && (
              <ProgressBar
                min={0}
                max={100}
                current={courseUtilities.calculateProgress(
                  courseRegistration.progress
                )}
              />
            )}
          </div>
        </div>
        <ul className="course-card-primary-actions">
          {showButtons && (
            <React.Fragment>
              {courseRegistration && !isLive && (
                <li className="actions-item">
                  <PlayButton courseRegistration={courseRegistration} />
                </li>
              )}

              {courseRegistration && isLive && (
                <li className="actions-item">
                  <DropCourseButton
                    courseRegistrationId={courseRegistration.id}
                  />
                </li>
              )}

              {!courseRegistration && (
                <li className="actions-item">
                  <LoadingSpinnerOverlay loading={isLoadingRegistration}>
                    <AddRemoveCartButton
                      courseOffering={this.props.courseOffering}
                    />
                  </LoadingSpinnerOverlay>
                </li>
              )}

              {!isLive &&
                courseRegistration &&
                !courseRegistration.attended && (
                  <li className="actions-item">
                    <DropCourseButton
                      courseRegistrationId={courseRegistration.id}
                    />
                  </li>
                )}
            </React.Fragment>
          )}

          {isLive && courseRegistration && (
            <li className="actions-item">
              <ICalButton id={courseOffering.id} />
            </li>
          )}
        </ul>
        
      </div>
    );
  }
}

CourseOfferingCard.propTypes = {
  history: PropTypes.object.isRequired,
  myCourses: PropTypes.bool.isRequired,
  isLoadingRegistration: PropTypes.bool.isRequired,
  currentUser: PropTypes.shape(User),
  courseOffering: PropTypes.shape(courseOffering).isRequired,
  showButtons: PropTypes.bool,
  actions: PropTypes.object.isRequired,
};

CourseOfferingCard.defaultProps = {
  showButtons: true,
  myCourses: false,
};

function mapStateToProps(state) {
  return {
    currentUser: state.auth.currentUser,
    isLoadingRegistration:
      selectIsLoadingRegisteredCourses(state) === loadingStates.LOADING,
  };
}

function mapDispatchToProps(dispatch) {
  const combinedActions = objectAssign({}, courseActions);

  return {
    actions: bindActionCreators(combinedActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CourseOfferingCard)
);
